import script from "./MaterialsForTeachersView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialsForTeachersView.vue?vue&type=script&setup=true&lang=js"

import "./MaterialsForTeachersView.vue?vue&type=style&index=0&id=92a5b5dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92a5b5dc"]])

export default __exports__